// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-social{-webkit-appearance:none;-moz-appearance:none;background-color:transparent;border:0;cursor:pointer;font-family:Avenir Next W02,sans-serif;margin:0;padding:0;text-align:center;text-decoration:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
